import React from 'react'
import dayjs from 'dayjs'
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers'

/**
 * Returns a date (the date components don't matter; it just uses today's date) with the
 * provided time.
 *
 * @param {String} string A timestring formatted hh:mm:ss
 */
const getDateFromTimeString = (string: string) => {
  if (string == null) return null
  const [hours, minutes, seconds] = string.split(':')
  const date = new Date()
  date.setHours(parseInt(hours, 10))
  date.setMinutes(parseInt(minutes, 10))
  date.setSeconds(parseInt(seconds, 10))
  return date
}

/**
 * In-line time picker component. Inputs/outputs are all time strings formatted HH:mm:ss.
 * Time zone agnostic.
 */
const TimePicker = ({ time, onChange }: Props) => (
  <MuiTimePicker
    onChange={(date) => onChange(dayjs(date).format('HH:mm:ss'))}
    openTo='hours'
    value={dayjs(getDateFromTimeString(time))}
  />
)

type Props = {
  time: string
  onChange: (time: string) => void
}

export default TimePicker
